// extracted by mini-css-extract-plugin
module.exports = {"refer":"Referral_refer__1BAf9","refer_modal":"Referral_refer_modal__DN2sN"};